import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) =>
  createStyles({
    button: {
      marginTop: 10,
      minWidth: 192,
      minHeight: 50,
      [theme.breakpoints.down('sm')]: {
        minWidth: 300,
      },
    },
    loader: {
      color: '#FFF',
    },
  }),
);

export default useStyles;
